
import { Component, Vue, Prop } from "vue-property-decorator";
import { SMTasksServices, SMUser } from "@/store";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import ImageCandidate from "@/assets/images/people/person-1.png";
import ImageEmployer from "@/assets/images/people/people-3.png";
import backgroundImageEmployer from "@/assets/images/widgets/background-1.png";
import { CANDIDATE_ROLE, EMPLOYEE_ROLE, EMPLOYER_ROLE } from "@/constants/roles";
import { COS_SKILLED_WORKER_SERVICE } from "@/constants/services";

const hasTasksKeyLabel = "hasTasks";
const hasNoTasksKeyLabel = "hasNoTasks";

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class AdditionalInfo extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;
  @Prop({ type: Boolean, default: false }) readonly getDependantVisaEnable?: boolean;

  get isCandidate() {
    return SMUser.isCandidate;
  }

  get isEmployer() {
    return SMUser.isEmployer;
  }

  get computedProps() {
    const { jobTitle, name, list, listType } = this;

    const props = {
      title: this.$tc("title"),
      jobTitle,
      name,
      list,
      listType,
      tasksEnable: true,
    };

    if (this.isCandidate) {
      Object.assign(props, {
        image: ImageCandidate,
      });
    }

    if (this.isEmployer) {
      Object.assign(props, {
        image: ImageEmployer,
        backgroundImage: backgroundImageEmployer,
      });
    }

    return props;
  }

  get list() {
    // NOTE: DEV-8219. Maybe we need to append new status and step "Additional data & documents";
    const { caseType } = this;
    const role = SMUser.user?.role;

    if (!role) return [];

    if (caseType !== COS_SKILLED_WORKER_SERVICE) {
      const path = `list.${caseType}.${role}`;

      return this.$t(path) || [];
    }

    if ([CANDIDATE_ROLE, EMPLOYEE_ROLE].includes(role)) {
      const hasTasksLabelKey = SMTasksServices.candidateTasksToDo.length
        ? hasTasksKeyLabel
        : hasNoTasksKeyLabel;

      const path = `list.${caseType}.${role}.${hasTasksLabelKey}`;

      return this.$t(path) || [];
    }

    if ([EMPLOYER_ROLE].includes(role)) {
      const hasTasksLabelKey = SMTasksServices.employerTasksToDo.length
        ? hasTasksKeyLabel
        : hasNoTasksKeyLabel;

      const path = `list.${caseType}.${role}.${hasTasksLabelKey}`;

      return this.$t(path) || [];
    }

    return [];
  }
}
